import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { BehaviorSubject, Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public inAuthProcess = new BehaviorSubject<boolean>(false);
  
  constructor(private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) { }

  setInAuthProcess(isInAuthProcess: boolean) {
    this.inAuthProcess.next(isInAuthProcess);
  }

  getInAuthProcess(): Observable<boolean> {
    return this.inAuthProcess.asObservable();
  }

  get isLoggedIn() {
    return this.oidcSecurityService.isAuthenticated$;    
  }

  startAuthentication() {
    return of(this.oidcSecurityService.authorize());    
  }

  logout() {    
    this.oidcSecurityService.logoff().subscribe();
  }

  callback() {
    this.setInAuthProcess(false);
    this.oidcSecurityService.checkAuth().subscribe(resp => {  
      console.log(resp);
      let redirectUrl = localStorage['_STIHL_PT_redirectUrl'];
      if (redirectUrl) {
        this.router.navigateByUrl(redirectUrl);
        localStorage.removeItem('_STIHL_PT_redirectUrl');
      } else {
        this.router.navigateByUrl("/home");
      }      
    }, (err) => {
      console.error(err);
    });
  }

  getAccessToken() {
    return this.oidcSecurityService.getIdToken();
  }
}
